export default (name, preferredName, personType) => {
    if (!name)
        return '';
    switch (personType) {
        case 'Student': {
            return extractName(name, preferredName, false);
        }
        case 'Teacher': {
            return extractName(name, preferredName, true);
        }
        default: {
            return name;
        }
    }
};
const extractName = (name, preferredName, isTeacher) => {
    const FIRST_NAME = 2;
    const LAST_NAME = 3;
    const alphabetPattern = /[a-zA-Z]/;
    // 空白が一つ多い場合は除去する
    const names = name.split(' ').filter((part) => part !== '');
    // Numberで0, 1にする 基本的には0,1なので falseでよい
    let nameBit = false;
    // 海外ユーザーから日本ユーザーの名前を参照する時、特殊でMyouji Namaeという形式になっている
    // 通常のひらがなは なまえ みょうじになる
    // 1,0にするのでbitをtrue
    if (alphabetPattern.test(name) && isTeacher) {
        nameBit = true;
    }
    if (preferredName === FIRST_NAME) {
        return names[Number(nameBit)];
    }
    else if (preferredName === LAST_NAME) {
        return names[Number(!nameBit)];
    }
    else {
        return isTeacher ? `${names[1]} ${names[0]}` : name;
    }
};
